import {useContext} from 'preact/hooks';

import {AuthorizeContext} from './context';

export function useAuthorizeState() {
  const value = useContext(AuthorizeContext);

  if (!value.dispatch) {
    // eslint-disable-next-line no-console
    console.error(
      'Invalid attempt to use useAuthorizeState outside of Authorize provider',
    );
  }

  return value;
}
